<template>
  <v-data-table
    :page="page"
    :pageCount="numberOfPages"
    :options.sync="options"
    :server-items-length="totalItems"
    :headers="headers"
    :items="items"
    :search="search"
    :loading="loading"
    loading-text="Đang tải dữ liệu... Vui lòng chờ"
    :items-per-page="perPage"
    :footer-props="{
      showFirstLastPage: true
    }"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Người dùng</v-toolbar-title>
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Nhập từ khóa"
          single-line
          hide-details
          clearable
        />
        <v-spacer v-if="!userId"/>
        <v-btn
          v-if="!userId"
          color="primary"
          dark
          class="mb-2"
          v-on:click="showDialog()"
        >
          <v-icon left>mdi-plus</v-icon>
          thêm mới
        </v-btn>
        <Form 
          :showDialog="dialog" 
          :item="item" 
          @confirmed="onConfirmed" 
          @cancelled="onCancelled"
        />
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeDelete">Hủy bỏ</v-btn>
              <v-btn color="pink darken-1" text @click="deleteItemConfirm">Đồng ý</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogReset" max-width="500px">
          <v-card>
            <v-card-title class="headline">Bạn có chắc muốn đặt lại mật khẩu?</v-card-title>
            <v-card-actions>
              <v-spacer/>
              <v-btn color="primary darken-1" text @click="closeReset">Hủy bỏ</v-btn>
              <v-btn color="pink darken-1" text @click="resetPasswordConfirm">Đồng ý</v-btn>
              <v-spacer/>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:item.avt="{ item }">
      <v-avatar
        v-if="item.info.anh_dai_dien"
        color="blue"
        size="50"
        tile
        class="my-2"
      >
        <v-img
          :src="`${apiBaseUrl}/uploads/${item.info.anh_dai_dien}`"
          lazy-src="@/assets/NoImage.jpg"
          class="ma-2"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="green"
              />
            </v-row>
          </template>
        </v-img>
      </v-avatar>
      <v-avatar
        v-else
        color="blue"
        size="50"
        tile
        class="my-2"
      >
        <span class="white--text">{{item.name.substring(0,2).toUpperCase()}}</span>
      </v-avatar>
    </template>
    <template v-slot:[`item.id`]="{ index }">
      {{ (perPage * (page-1)) +  (index+1) }}
    </template>
    <template v-slot:item.status="{ item }">
      <v-chip
        v-if="item.status.is_active !== '0'"
        class="ma-2"
        color="success"
        label
        outlined
        small
      >
        <v-icon left>
          mdi-check
        </v-icon>
        Hoạt động
      </v-chip>
      <v-chip
        v-else
        class="ma-2"
        color="warning"
        label
        outlined
        small
      >
        <v-icon left>
          mdi-lock
        </v-icon>
        Khóa
      </v-chip>
    </template>
    <template v-slot:item.actions="{ item }">
      <div style="white-space: nowrap;">
        <v-btn
          icon
          color="warning"
          @click="resetPassword(item)"
        >
          <v-icon>
            mdi-lock-reset
          </v-icon>
        </v-btn>
        <v-btn
          icon
          color="primary"
          @click="editItem(item)"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
        <v-btn
          v-if="!userId"
          icon
          color="pink"
          @click="deleteItem(item)"
        >
          <v-icon>
            mdi-delete
          </v-icon>
        </v-btn>
      </div>
    </template>
    <template v-slot:item.roles="{ item }">
      <v-chip
        class="ma-2"
        v-for="(role, index) in item.roles"
        :key="index"
        small
      >
        {{role.name}}
      </v-chip>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Tải lại
      </v-btn>
    </template>
  </v-data-table>
</template>
<script>
  import Form from '@/views/admin/users/acl/Form';
  import { mapActions, mapState } from 'vuex';
  export default {
    components: {
      Form,
    },
    props: {
      userId: {
        type: Number
      }
    },
    data: () => ({
      loading: false,
      dialog: false,
      dialogDelete: false,
      dialogReset: false,
      search: '',
      headers: [
        { text: 'STT', value: 'id' },
        { text: 'Avatar', value: 'avt'},
        { text: 'Tên', value: 'name' },
        { align: 'center', text: 'Vai trò', value: 'roles' },
        { text: 'Email Address', value: 'email' },
        { text: 'Trạng thái', value: 'status' },
        { text: 'Ngày tạo', value: 'created_at' },
        { 
          align: 'right', 
          text: 'Thao tác', 
          value: 'actions', 
          sortable: false 
        },
      ],
      page: 1,
      totalItems: 0,
      numberOfPages: 0,
      perPage: 10,
      options: {},
      items: [],
      types: [],
      editedIndex: -1,
      item: {}
    }),
    computed: {
      ...mapState([
        'config'
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'thêm mới' : 'cập nhật';
      },
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    watch: {
      options: {
        handler() {
          this.initialize();
        },
      },
      search(){
        this.initialize();
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      initialize () {
        const app = this;
        const { page, itemsPerPage } = app.options;
        let pageNumber = page;
        let url = "api/v1/users";
        if(app.userId){
          url = `api/v1/users/${app.userId}`;
        }
        let request = {
          params: {
            size: itemsPerPage,
            page: pageNumber,
            keyword: app.search,
          }
        };
        app.loading = true;
        axios.get(url, request)
          .then(response => {
            if(app.userId){
              app.items.push(response.data.data);
            } else {
              app.items = response.data.data;
              app.totalItems = response.data.total;
              app.numberOfPages = response.data.to;
              app.page = response.data.current_page;
              app.perPage = response.data.per_page;
            }
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      showDialog(item=null){
        this.item = item||{};
        this.dialog = true;
      },
      onConfirmed(item) {
        this.dialog = false; 
        this.initialize();
      },
      onCancelled () {
        this.dialog = false;
      },
      editItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogDelete = true;
      },
      deleteItemConfirm () {
        const app = this;
        axios.delete(`api/v1/users/${app.item.id}`)
          .then(function (resp) {
            app.items = app.items.filter(val => val.id !== app.item.id);
            app.closeDelete();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close () {
        this.dialog = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      closeDelete () {
        this.dialogDelete = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
      resetPassword (item) {
        this.editedIndex = this.items.indexOf(item);
        this.item = Object.assign({}, item);
        this.dialogReset = true;
      },
      resetPasswordConfirm () {
        const app = this;
        axios.patch(`api/v1/auth/reset-password/${app.item.id}`)
          .then(function (resp) {
            app.closeReset();
            app.openSnackbar({ type: 'success' });
          }).catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      closeReset () {
        this.dialogReset = false;
        this.$nextTick(() => {
          this.item = Object.assign({}, this.item);
          this.editedIndex = -1;
        })
      },
    }
  }
</script>